import type { ThemeConfig } from 'antd';

/**
 * 對齊 aws_website_miofive 的視覺語言（Bootstrap 風）：
 * - 主色藍 #3498db（登入按鈕/連結）、深板岩 #2c3e50（頂欄/表頭）、紅 #dc3545（危險/載入）
 * - 系統中文字體棧
 * - 表格表頭：深板岩底 + 白字 + 13px（miofive 招牌外觀）
 */
const SLATE = '#2c3e50';
const BLUE = '#3498db';
const RED = '#dc3545';
const FONT =
  'system-ui, -apple-system, BlinkMacSystemFont, "Microsoft YaHei UI", "Microsoft YaHei", "PingFang SC", sans-serif';

export const miofiveTheme: ThemeConfig = {
  token: {
    colorPrimary: BLUE,
    colorInfo: BLUE,
    colorError: RED,
    colorLink: BLUE,
    colorText: '#222222',
    fontFamily: FONT,
    borderRadius: 6,
  },
  components: {
    Layout: {
      headerBg: SLATE,
      headerColor: '#ffffff',
    },
    Menu: {
      itemSelectedColor: BLUE,
      itemSelectedBg: '#eaf4fb',
    },
    Table: {
      headerBg: SLATE,
      headerColor: '#ffffff',
      headerSortActiveBg: '#3a4f63',
      headerSortHoverBg: '#3a4f63',
      borderColor: '#dee2e6',
      fontSize: 13,
      cellFontSize: 13,
    },
    Button: {
      fontWeight: 500,
    },
  },
};
